{
  "PROFILE_SETTINGS": {
    "LINK": "Brukerinnstillinger",
    "TITLE": "Brukerinnstillinger",
    "BTN_TEXT": "Oppdater profil",
    "DELETE_AVATAR": "Delete Avatar",
    "AVATAR_DELETE_SUCCESS": "Avatar has been deleted successfully",
    "AVATAR_DELETE_FAILED": "There is an error while deleting avatar, please try again",
    "UPDATE_SUCCESS": "Your profile has been updated successfully",
    "PASSWORD_UPDATE_SUCCESS": "Ditt passord er endret",
    "AFTER_EMAIL_CHANGED": "Din profil har blitt oppdatert, vennligst logg inn igjen ettersom din innloggingsinformasjon er endret",
    "FORM": {
      "PICTURE": "Profile Picture",
      "EMAIL_SIGNATURE_PICTURE": {
        "LABEL": "Bilde til e-postsignatur",
        "HINT": "Brukes i e-postsignaturer. {'{{'}email_signature_picture{'}}'} erstattes med URL-adressen til dette bildet (ikke en img-tag) — bruk den som bildekilde (src i en img-tag) i signaturen din eller innboksens signatur. Hvis det ikke er angitt, settes ingenting inn.",
        "DELETE_SUCCESS": "Bildet til e-postsignaturen er slettet",
        "DELETE_FAILED": "Det oppstod en feil under sletting av bildet til e-postsignaturen, prøv igjen"
      },
      "AVATAR": "Profilbilde",
      "ERROR": "Vennligst fiks skjemafeil",
      "REMOVE_IMAGE": "Fjern",
      "UPLOAD_IMAGE": "Last opp bilde",
      "UPDATE_IMAGE": "Oppdater bilde",
      "PROFILE_SECTION": {
        "TITLE": "Profil",
        "NOTE": "Din e-postadresse er din identitet og brukes til å logge inn."
      },
      "SEND_MESSAGE": {
        "TITLE": "Hotkey to send messages",
        "NOTE": "You can select a hotkey (either Enter or Cmd/Ctrl+Enter) based on your preference of writing.",
        "UPDATE_SUCCESS": "Your settings have been updated successfully",
        "CARD": {
          "ENTER_KEY": {
            "HEADING": "Enter (↵)",
            "CONTENT": "Send messages by pressing Enter key instead of clicking the send button."
          },
          "CMD_ENTER_KEY": {
            "HEADING": "Cmd/Ctrl + Enter (⌘ + ↵)",
            "CONTENT": "Send messages by pressing Cmd/Ctrl + enter key instead of clicking the send button."
          }
        }
      },
      "INTERFACE_SECTION": {
        "TITLE": "Interface",
        "NOTE": "Tilpass utseendet og preget på dashbordet ditt.",
        "FONT_SIZE": {
          "TITLE": "Font size",
          "NOTE": "Adjust the text size across the dashboard based on your preference.",
          "UPDATE_SUCCESS": "Your font settings have been updated successfully",
          "UPDATE_ERROR": "There is an error while updating the font settings, please try again",
          "OPTIONS": {
            "SMALLER": "Smaller",
            "SMALL": "Small",
            "DEFAULT": "Default",
            "LARGE": "Large",
            "LARGER": "Larger",
            "EXTRA_LARGE": "Extra Large"
          }
        },
        "UI_LANGUAGE": {
          "TITLE": "Dashbordspråk",
          "NOTE": "Overstyr kontospråket for ditt eget dashbord. La stå tomt for å bruke kontoens standardinnstilling.",
          "USE_ACCOUNT_DEFAULT": "Bruk kontoens standardinnstilling",
          "API_SUCCESS": "Dashbordspråket ditt er oppdatert"
        },
        "MESSAGE_TRANSLATION": {
          "TITLE": "Meldingsspråk",
          "NOTE": "Velg om originalmeldinger eller oversettelsene deres skal vises",
          "ORIGINAL": "Original",
          "TRANSLATED": "Oversatt"
        },
        "PASTE_BEHAVIOR": {
          "TITLE": "Limeoppførsel",
          "NOTE": "Velg hvordan limt innhold skal behandles når du skriver meldinger",
          "UPDATE_SUCCESS": "Limeinnstillingene dine er oppdatert",
          "OPTIONS": {
            "PRESERVE_ALL": {
              "HEADING": "Behold all formatering",
              "DESCRIPTION": "Behold all formatering, inkludert tabeller, stiler og andre HTML-elementer, når du limer inn innhold."
            },
            "TEXT_WITH_LINKS": {
              "HEADING": "Kun tekst med lenker",
              "DESCRIPTION": "Konverter til ren tekst, men behold klikkbare lenker når du limer inn innhold."
            },
            "PLAIN_TEXT_ONLY": {
              "HEADING": "Kun ren tekst",
              "DESCRIPTION": "Fjern all formatering og konverter til ren tekst når du limer inn innhold."
            }
          }
        },
        "REPLY_BOX_HEIGHT": {
          "TITLE": "Høyde på svarfelt",
          "NOTE": "Angi minimumshøyden på svarfeltet som en prosentandel av skjermhøyden. Gjelder kun for e-postsamtaler.",
          "UPDATE_SUCCESS": "Innstillingen for høyde på svarfelt er oppdatert",
          "PERCENT_LABEL": "Høyde (% av skjermhøyden)",
          "OPTIONS": {
            "DEFAULT": {
              "HEADING": "Standard",
              "DESCRIPTION": "Svarfeltet starter lite og vokser etter hvert som du skriver."
            },
            "CUSTOM": {
              "HEADING": "Egendefinert",
              "DESCRIPTION": "Svarfeltet er alltid minst den valgte prosentandelen av skjermhøyden."
            }
          }
        }
      },
      "AUTO_NAVIGATION": {
        "TITLE": "Naviger automatisk til neste samtale",
        "NOTE": "Bytt automatisk til neste åpne samtale etter at den nåværende er løst",
        "UPDATE_SUCCESS": "Innstillingen for automatisk navigering er oppdatert"
      },
      "MESSAGE_SIGNATURE_SECTION": {
        "TITLE": "Personal message signature",
        "DESCRIPTION": "Opprett en unik meldingssignatur som vises nederst i hver e-post du sender. Du kan også inkludere et innebygd bilde.",
        "NOTE": "Create a unique message signature to appear at the end of every message you send from any inbox. You can also include an inline image, which is supported in live-chat, email, and API inboxes.",
        "BTN_TEXT": "Save message signature",
        "API_ERROR": "Couldn't save signature! Try again",
        "API_SUCCESS": "Signature saved successfully",
        "IMAGE_UPLOAD_ERROR": "Couldn't upload image! Try again",
        "IMAGE_UPLOAD_SUCCESS": "Image added successfully. Please click on save to save the signature",
        "IMAGE_UPLOAD_SIZE_ERROR": "Image size should be less than {size}MB"
      },
      "MESSAGE_SIGNATURE": {
        "LABEL": "Message Signature",
        "ERROR": "Message Signature cannot be empty",
        "PLACEHOLDER": "Insert your personal message signature here."
      },
      "PASSWORD_SECTION": {
        "TITLE": "Passord",
        "NOTE": "Oppdatering av passordet ditt nullstiller logger deg ut på andre enheter.",
        "BTN_TEXT": "Change password"
      },
      "ACCESS_TOKEN": {
        "TITLE": "Tilgangstoken",
        "NOTE": "Dette tokenet kan brukes hvis du lager en API-basert integrasjon",
        "COPY": "Kopier",
        "REGENERATE": "Generer på nytt",
        "REGENERATE_SUCCESS": "Tilgangstokenet er generert på nytt. Oppdater eventuelle integrasjoner som bruker det gamle tokenet.",
        "REGENERATE_CONFIRM_TITLE": "Generere tilgangstoken på nytt?",
        "REGENERATE_CONFIRM_MESSAGE": "Dette vil ugyldiggjøre det nåværende tokenet. Integrasjoner som bruker det gamle tokenet, slutter å fungere."
      },
      "CHROME_EXTENSION": {
        "TITLE": "Chrome-utvidelse",
        "NOTE": "Installer Chrome-utvidelsen vår for å få rike varsler om innkommende telefonsamtaler.",
        "INSTALL_BUTTON": "Installer utvidelse",
        "ALREADY_INSTALLED": "Utvidelse installert"
      },
      "AUDIO_NOTIFICATIONS_SECTION": {
        "TITLE": "Audio Alerts",
        "NOTE": "Enable audio alerts in dashboard for new messages and conversations.",
        "PLAY": "Play sound",
        "ALERT_TYPES": {
          "NONE": "None",
          "MINE": "Assigned",
          "ALL": "Alle",
          "ASSIGNED": "My assigned conversations",
          "UNASSIGNED": "Unassigned conversations",
          "NOTME": "Open conversations assigned to others"
        },
        "ALERT_COMBINATIONS": {
          "NONE": "You haven't selected any options, you won't receive any audio alerts.",
          "ASSIGNED": "You'll receive alerts for conversations assigned to you.",
          "UNASSIGNED": "You'll receive alerts for any unassigned conversations.",
          "NOTME": "You'll receive alerts for conversations assigned to others.",
          "ASSIGNED+UNASSIGNED": "You'll receive alerts for your assigned conversations and any unattended ones.",
          "ASSIGNED+NOTME": "You'll receive alerts for conversations assigned to you and to others, but not for unassigned ones.",
          "NOTME+UNASSIGNED": "You'll receive alerts for unattended conversations and those assigned to others.",
          "ASSIGNED+NOTME+UNASSIGNED": "You'll receive alerts for all conversations."
        },
        "ALERT_TYPE": {
          "TITLE": "Alert events for conversations",
          "NONE": "None",
          "ASSIGNED": "Assigned Conversations",
          "ALL_CONVERSATIONS": "All Conversations"
        },
        "DEFAULT_TONE": {
          "TITLE": "Alert tone:"
        },
        "CONDITIONS": {
          "TITLE": "Alert conditions:",
          "CONDITION_ONE": "Send audio alerts only if the browser window is not active",
          "CONDITION_TWO": "Send alerts every 10s until all the assigned conversations are read"
        },
        "SOUND_PERMISSION_ERROR": "Autoplay is disabled in your browser. To hear alerts automatically, enable sound permission in your browser settings or interact with the page.",
        "READ_MORE": "Read more"
      },
      "EMAIL_NOTIFICATIONS_SECTION": {
        "TITLE": "E-postvarsler",
        "NOTE": "Oppdater varslingsinnstillingene for e-post her",
        "CONVERSATION_ASSIGNMENT": "Send e-postvarsler når en samtale er tildelt meg",
        "CONVERSATION_CREATION": "Send e-postvarsler når en ny samtale opprettes",
        "CONVERSATION_MENTION": "Send varsel på e-post når du er nevnt i en samtale",
        "ASSIGNED_CONVERSATION_NEW_MESSAGE": "Send e-postvarsler når en ny melding opprettes i en tilordnet samtale",
        "PARTICIPATING_CONVERSATION_NEW_MESSAGE": "Send email notifications when a new message is created in a participating conversation",
        "SLA_MISSED_FIRST_RESPONSE": "Send email notifications when a conversation misses first response SLA",
        "SLA_MISSED_NEXT_RESPONSE": "Send email notifications when a conversation misses next response SLA",
        "SLA_MISSED_RESOLUTION": "Send email notifications when a conversation misses resolution SLA"
      },
      "NOTIFICATIONS": {
        "TITLE": "Notification preferences",
        "TYPE_TITLE": "Notification type",
        "EMAIL": "E-post",
        "PUSH": "Push notification",
        "TYPES": {
          "CONVERSATION_CREATED": "A new conversation is created",
          "CONVERSATION_ASSIGNED": "A conversation is assigned to you",
          "CONVERSATION_MENTION": "You are mentioned in a conversation",
          "ASSIGNED_CONVERSATION_NEW_MESSAGE": "A new message is created in an assigned conversation",
          "PARTICIPATING_CONVERSATION_NEW_MESSAGE": "A new message is created in a participating conversation",
          "UNASSIGNED_CONVERSATION_NEW_MESSAGE": "En ny melding er opprettet i en samtale uten tilgjengelig agent",
          "SLA_MISSED_FIRST_RESPONSE": "A conversation misses first response SLA",
          "SLA_MISSED_NEXT_RESPONSE": "A conversation misses next response SLA",
          "SLA_MISSED_RESOLUTION": "A conversation misses resolution SLA"
        },
        "BROWSER_PERMISSION": "Enable push notifications for your browser so you’re able to receive them",
        "ALLOW_NOTIFICATION_DURING_CALL": "Tillat push-varsler mens du er i en samtale",
        "TEST_PUSH": "Test",
        "TESTING": "Tester...",
        "TEST_PUSH_DESCRIPTION": "Send testvarsler for å bekrefte at oppsettet ditt fungerer",
        "TEST_NOTIFICATION_ERROR": "Kunne ikke sende testvarsel. Prøv igjen.",
        "TEST_LOCAL_TITLE": "Testvarsel (lokalt)",
        "TEST_LOCAL_BODY": "Dette er et lokalt nettleservarsel. Hvis du ser dette, fungerer nettleservarsler!"
      },
      "API": {
        "UPDATE_SUCCESS": "Dine varslingsinnstillinger er oppdatert",
        "UPDATE_ERROR": "Det oppstod en feil under oppdatering av innstillingene. Prøv igjen"
      },
      "PUSH_NOTIFICATIONS_SECTION": {
        "TITLE": "Pushvarsler",
        "NOTE": "Oppdater dine push-varslingsinnstillinger her",
        "CONVERSATION_ASSIGNMENT": "Send push-varsler når en samtale er tildelt meg",
        "CONVERSATION_CREATION": "Send push-varsler når en ny samtale opprettes",
        "CONVERSATION_MENTION": "Send pushvarslinger når du er nevnt i en samtale",
        "ASSIGNED_CONVERSATION_NEW_MESSAGE": "Send push-varsler når en ny melding opprettes i en tilordnet samtale",
        "PARTICIPATING_CONVERSATION_NEW_MESSAGE": "Send push notifications when a new message is created in a participating conversation",
        "HAS_ENABLED_PUSH": "Du har aktivert push-varsler for denne nettleseren.",
        "REQUEST_PUSH": "Aktiver push-varsler",
        "SLA_MISSED_FIRST_RESPONSE": "Send push notifications when a conversation misses first response SLA",
        "SLA_MISSED_NEXT_RESPONSE": "Send push notifications when a conversation misses next response SLA",
        "SLA_MISSED_RESOLUTION": "Send push notifications when a conversation misses resolution SLA"
      },
      "PROFILE_IMAGE": {
        "LABEL": "Profilbilde"
      },
      "NAME": {
        "LABEL": "Ditt fulle navn",
        "ERROR": "Vennligst oppgi et gyldig navn",
        "PLACEHOLDER": "Skriv inn fullt navn"
      },
      "DISPLAY_NAME": {
        "LABEL": "Visningsnavn",
        "ERROR": "Vennligst oppgi et gyldig visningsnavn",
        "PLACEHOLDER": "Skriv inn et visningsnavn, dette vil bli vist i samtaler"
      },
      "POSITION": {
        "LABEL": "Stilling",
        "ERROR": "Skriv inn en gyldig stilling",
        "PLACEHOLDER": "Skriv inn stillingen din"
      },
      "CUSTOM_LINE": {
        "LABEL": "Egendefinert linje",
        "ERROR": "Skriv inn en gyldig egendefinert linje",
        "PLACEHOLDER": "Skriv inn din egendefinerte linje"
      },
      "AVAILABILITY": {
        "LABEL": "Tilgjengelighet",
        "STATUS": {
          "ONLINE": "Pålogget",
          "BUSY": "Opptatt",
          "OFFLINE": "Frakoblet"
        },
        "SET_AVAILABILITY_SUCCESS": "Availability has been set successfully",
        "SET_AVAILABILITY_ERROR": "Couldn't set availability, please try again"
      },
      "EMAIL_PREVIEW_FORMAT": {
        "TITLE": "Format for e-postforhåndsvisning i samtaleliste",
        "NOTE": "Velg hva som vises i samtalelisten for samtaler fra e-postinnbokser",
        "SUBJECT": "Emne",
        "SUBJECT_WITH_NOTE": "Emne og siste melding hvis det er et privat notat",
        "UPDATE_SUCCESS": "Innstilling for e-postforhåndsvisning ble oppdatert"
      },
      "DISABLE_SHORTCUTS": {
        "TITLE": "Deaktiver hurtigtaster",
        "NOTE": "Slå av alle hurtigtaster i hele applikasjonen",
        "UPDATE_SUCCESS": "Innstillingen for hurtigtaster er oppdatert"
      },
      "FOLDER_ORDER": {
        "TITLE": "Mapperekkefølge",
        "NOTE": "Tilpass rekkefølgen mapper (egendefinerte visninger) vises i sidepanelet. Dra og slipp for å endre rekkefølgen.",
        "NO_FOLDERS": "Ingen egendefinerte mapper funnet. Opprett mapper for å organisere samtalene dine."
      },
      "SIDEBAR_CONFIGURATION": {
        "TITLE": "Konfigurasjon av sidepanel",
        "NOTE": "Tilpass hvilke seksjoner som vises i sidepanelet for samtaler.",
        "SAVE_BUTTON": "Lagre konfigurasjon",
        "UPDATE_SUCCESS": "Konfigurasjonen av sidepanelet er oppdatert",
        "UPDATE_ERROR": "Det oppstod en feil ved oppdatering av sidepanelkonfigurasjonen, prøv igjen",
        "OPTIONS": {
          "ALL_CONVERSATIONS": "Alle samtaler",
          "ALL_CONVERSATIONS_DESC": "Vis menyelementet Alle samtaler i sidepanelet",
          "INBOX": "Innboks",
          "INBOX_DESC": "Vis hovedinnboksen med uleste varsler",
          "CONVERSATION_GROUPS": "Omtaler og ubehandlede",
          "CONVERSATION_GROUPS_DESC": "Vis gruppene Omtaler og Ubehandlede samtaler",
          "FOLDERS": "Mapper",
          "FOLDERS_DESC": "Vis egendefinerte visninger (mapper) for organiserte samtaler",
          "TEAMS": "Team",
          "TEAMS_DESC": "Vis samtaler filtrert etter teamtildeling",
          "CHANNELS": "Innbokser",
          "CHANNELS_DESC": "Vis samtaler filtrert etter innboks",
          "LABELS": "Etiketter",
          "LABELS_DESC": "Vis samtaler filtrert etter etiketter"
        }
      },
      "PHONE_SETTINGS": {
        "TITLE": "Telefoninnstillinger",
        "NOTE": "Skriv inn påloggingsinformasjonen til PBX-systemet ditt.",
        "USERNAME": "Brukernavn",
        "PASSWORD": "Passord",
        "SUBMIT": "Lagre",
        "USERNAME_INVALID": "Brukernavnet kan bare inneholde bokstaver, tall og . _ - + — ingen mellomrom og ingen e-postadresse.",
        "API": {
          "USERNAME_INVALID": "Brukernavnet er ikke et gyldig SIP-brukernavn. Bruk bare bokstaver, tall og . _ - + — ingen mellomrom og ingen e-postadresse.",
          "USERNAME_TAKEN": "Dette brukernavnet er allerede i bruk av en annen agent på denne kontoen."
        }
      },
      "EMAIL": {
        "LABEL": "Din e-postadresse",
        "ERROR": "Vennligst skriv inn en gyldig e-postadresse",
        "PLACEHOLDER": "Vennligst skriv inn din e-postadresse, dette vises i samtaler"
      },
      "CURRENT_PASSWORD": {
        "LABEL": "Current password",
        "ERROR": "Please enter the current password",
        "PLACEHOLDER": "Please enter the current password"
      },
      "PASSWORD": {
        "LABEL": "New password",
        "ERROR": "Skriv inn et passord som er 6 eller flere tegn langt",
        "PLACEHOLDER": "Vennligst angi et nytt passord"
      },
      "PASSWORD_CONFIRMATION": {
        "LABEL": "Bekreft nytt passord",
        "ERROR": "Det bekreftende passordet burde samsvare med passordet",
        "PLACEHOLDER": "Please re-enter your new password"
      }
    }
  },
  "SIDEBAR_ITEMS": {
    "CHANGE_AVAILABILITY_STATUS": "Endre",
    "CHANGE_ACCOUNTS": "Switch account",
    "SWITCH_ACCOUNT": "Switch account",
    "CONTACT_SUPPORT": "Contact support",
    "REPORT_BUG": "Rapporter en feil",
    "SELECTOR_SUBTITLE": "Velg en konto fra følgende liste",
    "PROFILE_SETTINGS": "Profile settings",
    "KEYBOARD_SHORTCUTS": "Keyboard shortcuts",
    "APPEARANCE": "Change appearance",
    "SUPER_ADMIN_CONSOLE": "SuperAdmin console",
    "DOCS": "Read documentation",
    "LOGOUT": "Log out"
  },
  "BUG_REPORT": {
    "TITLE": "Rapporter en feil",
    "DESCRIPTION_LABEL": "Beskrivelse av problemet",
    "DESCRIPTION_PLACEHOLDER": "Beskriv problemet du støtte på...",
    "SUBMIT": "Send inn rapport",
    "SUBMITTING": "Sender inn...",
    "CANCEL": "Avbryt",
    "SUCCESS": "Feilrapporten er sendt inn. Takk!",
    "VALIDATION_ERROR": "Beskriv problemet før du sender inn"
  },
  "APP_GLOBAL": {
    "TRIAL_MESSAGE": "dager gjenværende av prøveperioden.",
    "TRAIL_BUTTON": "Kjøp nå",
    "DELETED_USER": "Deleted User",
    "EMAIL_VERIFICATION_PENDING": "It seems that you haven't verified your email address yet. Please check your inbox for the verification email.",
    "RESEND_VERIFICATION_MAIL": "Resend verification email",
    "EMAIL_VERIFICATION_SENT": "Verification email has been sent. Please check your inbox.",
    "ACCOUNT_SUSPENDED": {
      "TITLE": "Account Suspended",
      "MESSAGE": "Your account is suspended. Please reach out to the support team for more information."
    }
  },
  "COMPONENTS": {
    "CODE": {
      "BUTTON_TEXT": "Kopier",
      "CODEPEN": "Open in CodePen",
      "COPY_SUCCESSFUL": "Koden er kopiert til utklippstavlen"
    },
    "SHOW_MORE_BLOCK": {
      "SHOW_MORE": "Show More",
      "SHOW_LESS": "Show Less"
    },
    "FILE_BUBBLE": {
      "DOWNLOAD": "Last ned",
      "UPLOADING": "Laster opp...",
      "INSTAGRAM_STORY_UNAVAILABLE": "Denne historien er ikke lenger tilgjengelig.",
      "RECORDING_UNAVAILABLE": "Dette opptaket er ikke lenger tilgjengelig.",
      "DELETE_RECORDING": {
        "BUTTON": "Slett samtaleopptak",
        "TITLE": "Slette samtaleopptaket?",
        "DESCRIPTION": "Alle opptak av denne samtalen slettes permanent fra telefonsystemet og kan ikke gjenopprettes. Transkripsjonen og sammendraget av samtalen beholdes.",
        "CONFIRM": "Slett",
        "SUCCESS": "Samtaleopptaket er slettet",
        "ERROR": "Kunne ikke slette samtaleopptaket. Prøv igjen."
      }
    },
    "LOCATION_BUBBLE": {
      "SEE_ON_MAP": "See on map"
    },
    "FORM_BUBBLE": {
      "SUBMIT": "Send"
    },
    "MEDIA": {
      "IMAGE_UNAVAILABLE": "This image is no longer available.",
      "LOADING_FAILED": "Loading failed"
    }
  },
  "CONFIRM_EMAIL": "Verifiserer...",
  "SETTINGS": {
    "INBOXES": {
      "NEW_INBOX": "Legg til innboks"
    }
  },
  "SIDEBAR": {
    "NO_ITEMS": "No items",
    "CURRENTLY_VIEWING_ACCOUNT": "Currently viewing:",
    "SWITCH": "Switch",
    "INBOX_VIEW": "Inbox View",
    "CONVERSATIONS": "Samtaler",
    "INBOX": "My Inbox",
    "ALL_CONVERSATIONS": "All Conversations",
    "MENTIONED_CONVERSATIONS": "Omtale",
    "PARTICIPATING_CONVERSATIONS": "Participating",
    "UNATTENDED_CONVERSATIONS": "Unattended",
    "REPORTS": "Rapporter",
    "SETTINGS": "Innstillinger",
    "CONTACTS": "Kontakter",
    "DATA_ASSISTANT": "Dataassistent",
    "CAPTAIN": "Captain",
    "CAPTAIN_ASSISTANTS": "Assistants",
    "CAPTAIN_DOCUMENTS": "Documents",
    "CAPTAIN_RESPONSES": "FAQs",
    "HOME": "Hjem",
    "AGENTS": "Agenter",
    "AGENT_BOTS": "Bots",
    "AUDIT_LOGS": "Audit Logs",
    "WHATSAPP_TEMPLATES": "WhatsApp-maler",
    "BLOCKED_DOMAINS": "SPAM",
    "INBOXES": "Innbokser",
    "NOTIFICATIONS": "Varsler",
    "CANNED_RESPONSES": "Forhåndslagde svar",
    "INTEGRATIONS": "Integrasjoner",
    "PROFILE_SETTINGS": "Brukerinnstillinger",
    "ACCOUNT_SETTINGS": "Kontoinnstillinger",
    "APPLICATIONS": "Applications",
    "LABELS": "Etiketter",
    "CUSTOM_ATTRIBUTES": "Egendefinerte verdier",
    "AUTOMATION": "Automation",
    "MACROS": "Macros",
    "TEAMS": "Teams",
    "BILLING": "Billing",
    "CUSTOM_VIEWS_FOLDER": "Folders",
    "CUSTOM_VIEWS_SEGMENTS": "Segments",
    "ALL_CONTACTS": "All Contacts",
    "TAGGED_WITH": "Tagged with",
    "NEW_LABEL": "New label",
    "NEW_TEAM": "New team",
    "NEW_INBOX": "New inbox",
    "REPORTS_CONVERSATION": "Samtaler",
    "CSAT": "CSAT",
    "LIVE_CHAT": "Live Chat",
    "SMS": "SMS",
    "CAMPAIGNS": "Campaigns",
    "ONGOING": "Ongoing",
    "ONE_OFF": "One off",
    "REPORTS_SLA": "SLA",
    "REPORTS_BOT": "Bot",
    "REPORTS_AGENT": "Agenter",
    "REPORTS_LABEL": "Etiketter",
    "REPORTS_INBOX": "Inbox",
    "REPORTS_TEAM": "Team",
    "REPORTS_PHONE": "Telefon",
    "WALLBOARD": "Wallboard",
    "WALLBOARD_OVERVIEW": "Oversikt",
    "WALLBOARD_QUEUES": "Køer",
    "DATA_ASSISTANT_CHAT": "Chat",
    "DATA_ASSISTANT_REPORTS": "Rapporter",
    "NO_WAITING_CALLERS": "ingen ventende innringere",
    "WAITING_CALLERS": "{count} innringere venter",
    "SET_AVAILABILITY_TITLE": "Set yourself as",
    "SET_YOUR_AVAILABILITY": "Set your availability",
    "AVAILABILITY_IMPERSONATING": "Låst mens du er logget inn som denne brukeren",
    "SLA": "SLA",
    "CUSTOM_ROLES": "Custom Roles",
    "NEW_CONVERSATION": "Ny samtale",
    "DRAFT": "Utkast",
    "BETA": "Beta",
    "REPORTS_OVERVIEW": "Overview",
    "REAUTHORIZE": "Your inbox connection has expired, please reconnect\n to continue receiving and sending messages",
    "HELP_CENTER": {
      "TITLE": "Help Center",
      "ARTICLES": "Articles",
      "CATEGORIES": "Categories",
      "LOCALES": "Locales",
      "SETTINGS": "Innstillinger",
      "DICTIONARY": "Ordbok"
    },
    "CHANNELS": "Kanaler",
    "SET_AUTO_OFFLINE": {
      "TEXT": "Mark offline automatically",
      "INFO_TEXT": "Let the system automatically mark you offline when you aren't using the app or dashboard.",
      "INFO_SHORT": "Automatically mark offline when you aren't using the app."
    },
    "DOCS": "Read docs"
  },
  "BLOCKED_DOMAINS_SETTINGS": {
    "HEADER": "Blokkerte domener og kontakter",
    "DESCRIPTION": "Liste over blokkerte e-postdomener for denne kontoen.",
    "NO_BLOCKED_DOMAINS": "Ingen blokkerte domener funnet.",
    "BLOCKED_CONTACTS_BTN": "Blokkerte kontakter"
  },
  "BILLING_SETTINGS": {
    "TITLE": "Billing",
    "DESCRIPTION": "Manage your subscription here, upgrade your plan and get more for your team.",
    "CURRENT_PLAN": {
      "TITLE": "Current Plan",
      "PLAN_NOTE": "You are currently subscribed to the **{plan}** plan with **{quantity}** licenses",
      "SEAT_COUNT": "Number of seats",
      "RENEWS_ON": "Renews on"
    },
    "VIEW_PRICING": "View Pricing",
    "MANAGE_SUBSCRIPTION": {
      "TITLE": "Manage your subscription",
      "DESCRIPTION": "View your previous invoices, edit your billing details, or cancel your subscription.",
      "BUTTON_TXT": "Go to the billing portal"
    },
    "CAPTAIN": {
      "TITLE": "Captain",
      "DESCRIPTION": "Manage usage and credits for Captain AI.",
      "BUTTON_TXT": "Buy more credits",
      "DOCUMENTS": "Documents",
      "RESPONSES": "Responses",
      "UPGRADE": "Captain is not available on the free plan, upgrade now to get access to assistants, copilot and more."
    },
    "CHAT_WITH_US": {
      "TITLE": "Need help?",
      "DESCRIPTION": "Do you face any issues in billing? We are here to help.",
      "BUTTON_TXT": "Chat med oss"
    },
    "NO_BILLING_USER": "Your billing account is being configured. Please refresh the page and try again."
  },
  "CREATE_ACCOUNT": {
    "NO_ACCOUNT_WARNING": "Å nei! Vi fant ingen kontoer. Opprett en ny konto for å fortsette.",
    "NEW_ACCOUNT": "Ny konto",
    "SELECTOR_SUBTITLE": "Opprett ny konto",
    "API": {
      "SUCCESS_MESSAGE": "Kontoen ble opprettet",
      "EXIST_MESSAGE": "Kontoen eksisterer allerede",
      "ERROR_MESSAGE": "Kunne ikke koble til Woot Server, vennligst prøv igjen senere"
    },
    "FORM": {
      "NAME": {
        "LABEL": "Firmaets navn",
        "PLACEHOLDER": "Ola's bedrift"
      },
      "SUBMIT": "Send",
      "CANCEL": "Avbryt"
    }
  },
  "KEYBOARD_SHORTCUTS": {
    "TOGGLE_MODAL": "View all shortcuts",
    "TITLE": {
      "OPEN_CONVERSATION": "Open conversation",
      "RESOLVE_AND_NEXT": "Resolve and move to next",
      "NAVIGATE_DROPDOWN": "Navigate dropdown items",
      "RESOLVE_CONVERSATION": "Resolve Conversation",
      "GO_TO_CONVERSATION_DASHBOARD": "Go to Conversation Dashboard",
      "ADD_ATTACHMENT": "Add Attachment",
      "GO_TO_CONTACTS_DASHBOARD": "Go to Contacts Dashboard",
      "TOGGLE_SIDEBAR": "Toggle Sidebar",
      "GO_TO_REPORTS_SIDEBAR": "Go to Reports sidebar",
      "MOVE_TO_NEXT_TAB": "Move to next tab in conversation list",
      "GO_TO_SETTINGS": "Go to Settings",
      "SWITCH_TO_PRIVATE_NOTE": "Switch to Private Note",
      "SWITCH_TO_REPLY": "Switch to Reply",
      "TOGGLE_SNOOZE_DROPDOWN": "Toggle snooze dropdown",
      "AI_ASSIST_MENU": "AI-assistanse",
      "AI_ASSIST_GRAMMAR": "Rett grammatikk",
      "AI_ASSIST_UNIFY_LANG": "Enhetliggjør meldingsspråk"
    }
  }
}
